module.exports = __webpack_public_path__ + "static/media/Informationbanner@2x.95be43ff.png";